"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderSpinnerModal = exports.StyledSpinnerWrapper = exports.StyledSpinnerContainer = exports.StyledModalWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const spinner_icon_1 = require("../icons/spinner-icon");
exports.StyledModalWrapper = components_core_1.styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;
exports.StyledSpinnerContainer = components_core_1.styled.div `
  display: inline-block;
`;
exports.StyledSpinnerWrapper = components_core_1.styled.div `
  display: flex;
  background: #fff;
  padding: 50px 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 25px 1px rgba(0, 0, 0, 0.2);

  & > :first-child {
    margin-bottom: 20px;
  }
`;
const LoaderSpinnerModal = (props) => {
    const { label } = props;
    return (react_1.default.createElement(exports.StyledModalWrapper, { className: "loader-spinner-modal-container" },
        react_1.default.createElement(exports.StyledSpinnerContainer, { className: "spinner-container" },
            react_1.default.createElement(exports.StyledSpinnerWrapper, { className: "spinner-wrapper" },
                react_1.default.createElement(spinner_icon_1.SpinnerIcon, { iconSize: "60" }),
                react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy200 }, label ? label : 'Loading...')))));
};
exports.LoaderSpinnerModal = LoaderSpinnerModal;
